import React from 'react';
import { Route } from 'react-router-dom';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

import Tabs from './Tabs';

function Dashboards() {
  return (
    <Route
      render={(props) => (
        <>
          <Can I="list" a="Dashboards">
            {() => <Tabs {...props} />}
          </Can>
          <Can not I="list" a="Dashboards">
            {() => <NotPermissionPage />}
          </Can>
        </>
      )}
    />
  );
}
export default React.memo(Dashboards);
